var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.176 9.874c0 .836-.754 1.513-1.684 1.513H2.508c-.93 0-1.684-.677-1.684-1.513v-2.52c0-.28.25-.505.561-.505.31 0 .562.226.562.504v2.521c0 .279.25.505.561.505h8.984c.31 0 .561-.226.561-.505v-2.52c0-.28.252-.505.562-.505.31 0 .561.226.561.504zm-3.46-4.289a.466.466 0 0 1 0 .713L7.453 8.315a.617.617 0 0 1-.8 0L4.385 6.298a.466.466 0 0 1 0-.713.617.617 0 0 1 .801 0L6.485 6.74V1.339c0-.265.182-.486.422-.532L7 .8c.284 0 .515.242.515.54v5.494l1.4-1.248a.62.62 0 0 1 .723-.058z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ee42522b521e1057448519355c24232e.svg";
export { ForwardRef as ReactComponent };